import { ErrorBoundary } from '@components/common/ErrorBoundary/ErrorBoundary'
import BlogPostGrid from '@components/modules/BlogPostGrid/BlogPostGrid'
import BlogPostSlider from '@components/modules/BlogPostSlider/BlogPostSlider'
import BookComponent from '@components/modules/BookComponent/BookComponent'
import BrandStory from '@components/modules/BrandStory'
import CategoryHero from '@components/modules/CategoryHero/CategoryHero'
import ContactComponent from '@components/modules/ContactComponent/ContactComponent'
import FaqModule from '@components/modules/FaqModule/FaqModule'
import FurnitureViewer from '@components/modules/FurnitureViewer/FurnitureViewer'
import HeroImage from '@components/modules/HeroImage/HeroImage'
import HeroMediaSlider from '@components/modules/HeroMediaSlider/HeroMediaSlider'
import HeroSlider from '@components/modules/HeroSlider/HeroSlider'
import ImageComponent from '@components/modules/ImageComponent/ImageComponent'
import ImageTextStacked from '@components/modules/ImageTextStacked/ImageTextStacked'
import ImageWithContent from '@components/modules/ImageWithContent/ImageWithContent'
import LoginForm from '@components/modules/LoginForm/LoginForm'
import M453Images3Texts from '@components/modules/M453Images3Texts/M453Images3Texts'
import NewsletterSignup from '@components/modules/NewsletterSignup/NewsletterSignup'
import ProductGrid from '@components/modules/ProductGrid/ProductGrid'

import ProductSlider from '@components/modules/ProductSlider/ProductSlider'
import RichText from '@components/modules/RichText/RichText'
import RichTextColumn from '@components/modules/RichTextColumn/RichTextColumn'
import ScriptComponent from '@components/modules/ScriptComponent/ScriptComponent'
import ScrollRevealText from '@components/modules/ScrollRevealText/ScrollRevealText'
import ScrollVideo from '@components/modules/ScrollVideo/ScrollVideo'
import Spacer from '@components/modules/Spacer/Spacer'
import StoreLocator from '@components/modules/StoreLocator/StoreLocator'
import ThreeImagesWithText from '@components/modules/ThreeImagesWithText/ThreeImagesWithText'
import TrendGridView from '@components/modules/TrendGridView/TrendGridView'
import TwoImages from '@components/modules/TwoImages/TwoImages'
import TwoImagesTwoTexts from '@components/modules/TwoImagesTwoTexts/TwoImagesTwoTexts'
import UPSBanner from '@components/modules/UPSBanner/UPSBanner'
import WishList from '@components/modules/WishList/WishList'
import Image from '@components/ui/Image/Image'

import Product from '@components/views/Product/Product'
import Confirmation from 'features/checkout/views/Confirmation/Confirmation'
import { FC } from 'react'
import M55SignupForm from '../../features/account/components/M55SignupForm/M55SignupForm'
import M56LoginForm from '../../features/account/components/M56LoginForm/M56LoginForm'
import M58ForgotPasswordForm from '../../features/account/components/M58ForgotPasswordForm/M58ForgotPasswordForm'
import M59OrdersList from '../../features/account/components/M59OrdersList/M59OrdersList'
import M60OrderView from '../../features/account/components/M60OrderView/M60OrderView'
import M61ProfileView from '../../features/account/components/M61ProfileView/M61ProfileView'
import CaseStories from './CaseStories/CaseStories'
import ContactForm from './ContactForm/ContactForm'
import CustomProductGrid from './CustomProductGrid/CustomProductGrid'
import M21 from './M21/M21'
import M46 from './M46/M46'
import M47 from './M47/M47'
import M54CardBlock from './M54CardBlock/M54CardBlock'
import M57GeneralComponent from './M57GeneralComponent/M57GeneralComponent'
import M62IconRenderer from './M62IconRenderer/M62IconRenderer'
import M63RichTextWithBackground from './M63RichTextWithBackground/M63RichTextWithBackground'
import M65VividWorks from './M65VividWorks/M65VividWorks'
import M9 from './M9/M9'
import ProductScrollBanner from './ProductScrollBanner/ProductScrollBanner'
import ProductScrollInformation from './ProductScrollInformation/ProductScrollInformation'
import StoriesPostGrid from './StoriesPostGrid/StoriesPostGrid'
import StoriesText from './StoriesText/StoriesText'

export type ModuleProps = {
  __typename?: string
  lcp?: boolean
}
const Module: FC<ModuleProps> = ({ __typename, ...props }) => {
  const ModuleType: any = {
    RichText,
    HeroMediaSlider,
    HeroImage,
    ImageWithContent,
    Spacer,
    ImageComponent,
    Book: BookComponent,
    BlogPostGrid,
    BlogPostSlider,
    ThreeImagesWithText,
    TwoImagesTwoTexts,
    TwoImages,
    ImageTextStacked,
    Image,
    CategoryHero,
    ProductSlider,
    ScrollVideo,
    NewsletterSignup,
    BrandStory,
    UPSBanner,
    ConfirmComponent: Confirmation,
    LoginForm,
    RichTextColumn,
    ProductView: Product,
    StoreLocatorComponent: StoreLocator,
    ScriptComponent,
    WishList,
    ProductGrid,
    ContactList: ContactComponent,
    FaqModule,
    FurnitureViewer,
    InspirationComponent: TrendGridView,
    M1ContactForm: ContactForm,
    HeroSlider,
    ScrollRevealText,
    M453Images3Texts,
    M46,
    M47,
    M9,
    M21,
    StoriesText,
    StoriesPostGrid,
    CustomProductGrid,
    CaseStories,
    ProductScrollBanner,
    ProductScrollInformation,
    M54CardBlock,
    M55SignupForm,
    M56LoginForm,
    M57GeneralComponent,
    M58ForgotPasswordForm,
    M59OrdersList,
    M60OrderView,
    M61ProfileView,
    M62IconRenderer,
    M63RichTextWithBackground,
    M65VividWorks,
  }[__typename]

  return (
    <ErrorBoundary>
      {ModuleType ? (
        <ModuleType {...props} __typename={__typename} />
      ) : (
        <div data-type={__typename}></div>
      )}
    </ErrorBoundary>
  )
}
export default Module
